import {createStyles, WithStyles, withStyles} from '@material-ui/core';
import DialogContent from '@material-ui/core/DialogContentText';
import React from 'react';

const styles = () =>
  createStyles({
    content: {
      paddingLeft: '6%',
      paddingTop: 10,
    },
  });

interface ContentProps extends WithStyles<typeof styles> {
  text?: string;
}

const Content = withStyles(styles)(({text, classes}: ContentProps) => (
  <DialogContent className={classes.content}>{text}</DialogContent>
));

export default Content;
